import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useFontReady } from '../contexts/FontReadyContext';
import TidleLoadingSpinner from '../components/TidleLoadingSpinner';

function RedirectPage() {
  const navigate = useNavigate();
  const { currentUser, loading, authReady, authIntent } = useAuth();
  const fontReady = useFontReady();

  // Redirect logic - wait for auth to be ready
  useEffect(() => {
    // Wait for auth to finish initializing (either has user or anonymous sign-in complete)
    if (!loading && authReady) {
      if (currentUser) {
        // User exists (authenticated or anonymous) - navigate to /main
        navigate('/main');
      } else {
        // No user - check auth intent
        if (authIntent === 'login') {
          // User explicitly logged out - route to /login (NOT /main, NOT /register)
          navigate('/login');
        } else {
          // Default guest intent - first-time visitors go to landing page
          navigate('/landing');
        }
      }
    }
  }, [currentUser, loading, authReady, authIntent, navigate]);

  if (loading || !authReady || !fontReady) {
    return <TidleLoadingSpinner />;
  }

  return null;
}

export default RedirectPage;